<template lang="pug">
  div
    template(v-if="!isMobile")
      .layout-view__controls
        v-btn(
          :disabled="!hasPermission('ingredient', 'add')"
          medium
          @click="modals.showCreate = true")
          v-icon.mr-1(
            position-left
            font-size="1"
            icon="plus")
          span {{ 'base.add_ingredient' | translate }}
    template(v-else)
      v-btn(
        :disabled="!hasPermission('ingredient', 'add')"
        fab
        @click="modals.showCreate = true")
        v-icon(
          font-size="1.2"
          icon="plus")

    v-dialog(
      max-width="350"
      v-model="modals.showCreate")
      create-modal(
        @update="handleUpdate"
        @close="modals.showCreate = false")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import CreateModal from './modals/CreateModal'

export default {
  name: 'ControlsPanel',

  mixins: [adaptationMixin],

  components: {
    CreateModal
  },

  data: () => ({
    modals: {
      showCreate: false,
      stock: null
    }
  }),
  methods: {
    handleUpdate (stock) {
      this.$emit('update', stock)
    },
  }
}
</script>
